export default "__VITE_ASSET__VsEJ1YM4__"